<template>
    <div class="page-layout-settings">
        <div v-if="hasSidebar" class="page-layout-settings__sidebar">
            <slot name="sidebar"></slot>
        </div>
        <div class="page-layout-settings__content">
            <slot name="content"></slot>
        </div>
    </div>
</template>
<script>
export default {
    provide() {
        return {
            pageLayoutSettings: this,
        };
    },
    data() {
        return {
            hasSidebar: true,
        };
    },
};
</script>
<style lang="scss" scoped>
.page-layout-settings {
    display: flex;
    gap: var(--spacing-4);
    padding: 0 0 var(--spacing-4);

    &__sidebar {
        flex-shrink: 0;
        width: 216px;
    }

    &__content {
        margin: 0 auto;
        max-width: 1200px;
        min-width: 0;
        width: 100%;
    }
}
</style>
